var render = function render(){
  var _vm$product, _vm$product2, _vm$product2$stockOrd;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "overflow-hidden"
  }, [_c('v-radio-group', _vm._b({
    on: {
      "change": _vm.emit
    },
    model: {
      value: _vm.deliveryType,
      callback: function ($$v) {
        _vm.deliveryType = $$v;
      },
      expression: "deliveryType"
    }
  }, 'v-radio-group', _vm.attrs_controls_common, false), [_c('v-radio', {
    attrs: {
      "label": "단건배송",
      "value": "single"
    }
  }), (_vm$product = _vm.product) !== null && _vm$product !== void 0 && _vm$product.regularDeliveryEnabled ? _c('v-radio', {
    attrs: {
      "label": "정기배송",
      "value": "regular"
    }
  }) : _vm._e(), (_vm$product2 = _vm.product) !== null && _vm$product2 !== void 0 && (_vm$product2$stockOrd = _vm$product2.stockOrderConf) !== null && _vm$product2$stockOrd !== void 0 && _vm$product2$stockOrd.enabled ? _c('v-radio', {
    attrs: {
      "label": "재고주문",
      "value": "stock"
    }
  }) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }